import React, { FC, ReactNode } from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import {
  pageOffsets,
  layoutOffsets,
  maxWidths,
} from '../../core/styles/theme/layout';
import { mixins } from '../../core/styles/theme/default';

const containerPadding = css`
  ${mixins.responsiveStyles({
    'padding-left': pageOffsets,
    'padding-right': pageOffsets,
  })}
`;

const containerPaddingLayout = css`
  ${mixins.responsiveStyles({
    'padding-left': layoutOffsets,
    'padding-right': layoutOffsets,
  })}
`;

const containerWidth = css`
  ${mixins.responsiveStyles({
    'max-width': maxWidths,
  })}
`;

const StyledContainer = styled.div(
  ({ fullWidth, noOffsets, layout }: ContainerProps) => css`
    margin: 0 auto;
    max-width: 100%;
    ${!fullWidth && containerWidth};
    ${!noOffsets && !layout && containerPadding};
    ${!noOffsets && layout && containerPaddingLayout};
  `,
);

const Container: FC<ContainerProps> = ({
  children,
  ...rest
}: ContainerProps) => {
  return <StyledContainer {...rest}>{children}</StyledContainer>;
};

export type ContainerProps = {
  /** disable the maxWidth constrains */
  fullWidth?: boolean;
  /** disable the left / right indention */
  noOffsets?: boolean;
  children?: ReactNode;
  layout?: boolean;
};

export default Container;
